import { designFastVariables } from "store/calculation.config";

export const calculateAccelerationAlongSlope = ({initialSpeed, slope, designVehicle, speedlimit}) => {

    const vehicle = designVehicle;

    let dt = 0.025;
    let result = {
        time: [0],
        distance: [0],
        speed: [initialSpeed],
        errors: []
    }

    let slowingDownIndex = 0;

    while(result.speed[result.speed.length-1] < Math.min(speedlimit + 10, vehicle.maxSpeed))
    {
        let currentUtilizationRate;
        let utilizationRateDelta = ((vehicle.maxUtilizationRate + slope * vehicle.maxUtilizationRateDelta) - (vehicle.minUtilizationRate + slope * vehicle.minUtilizationRateDelta))/(vehicle.maxUtilizationRateSpeed - vehicle.minUtilizationRateSpeed);

        if(result.speed[result.speed.length-1] > vehicle.maxUtilizationRateSpeed) currentUtilizationRate = vehicle.maxUtilizationRate + slope * vehicle.maxUtilizationRateDelta;
        else if(result.speed[result.speed.length-1] < vehicle.minUtilizationRateSpeed) currentUtilizationRate = vehicle.minUtilizationRate + slope * vehicle.minUtilizationRateDelta;
        else currentUtilizationRate = (vehicle.minUtilizationRate + slope * vehicle.minUtilizationRateDelta) + utilizationRateDelta * (result.speed[result.speed.length-1] - vehicle.minUtilizationRateSpeed);

        let tractionForce = vehicle.effect * currentUtilizationRate / (result.speed[result.speed.length-1]/3.6);
        let gravitationalForce = 9.81 * vehicle.mass * slope;
        let rollingResistance = 9.81 * vehicle.mass * designFastVariables.rollingResistance;
        let airResistance = 0.5 * designFastVariables.airDensity * vehicle.airResistance * vehicle.frontArea * ((result.speed[result.speed.length-1]/3.6)**2);
        let forcesSum = tractionForce - gravitationalForce - rollingResistance - airResistance;
        let acceleration = forcesSum/vehicle.mass;

        if(result.speed[result.speed.length-1]/3.6 + acceleration * dt > vehicle.maxSpeed/3.6) acceleration = (vehicle.maxSpeed/3.6 - result.speed[result.speed.length-1]/3.6)/dt;

        if(result.speed[result.speed.length-1] + 3.6 * dt * acceleration < result.speed[result.speed.length-2])
        {
            slowingDownIndex++;
            if(slowingDownIndex > 50)
            {
                result.errors.push("TOOLS_ACCELERATION_NOT_POSSIBLE_VEHICLE_NOT_ACCELERATING")
                break;
            }
        }
        else
        {
            slowingDownIndex = 0;
        }

        if(result.speed[result.speed.length-50])
        {
            if(Math.abs(result.speed[result.speed.length-1] - result.speed[result.speed.length-50]) < 0.025)
            {
                result.errors.push("TOOLS_ACCELERATION_NOT_POSSIBLE_VEHICLE_NOT_ACCELERATING")
                break;
            }
        }

        result.time.push(result.time[result.time.length-1]+dt);
        result.speed.push(result.speed[result.speed.length-1] + 3.6 * dt * acceleration);
        result.distance.push(result.distance[result.distance.length-1] + (result.speed[result.speed.length-1]/3.6 * dt) + (0.5 * acceleration * dt**2));
    };

    const accelerationData = [];
    for(let i = 0; i < Math.min(result.speed.length, result.time.length, result.distance.length); i++)
    {
        accelerationData.push({
            speed: result.speed[i],
            distance: result.distance[i],
            time: result.time[i]
        });
    }

    return {
        accelerationData,
        accelerationErrors: result.errors
    }
}